import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatSeniority',
  standalone: false,
})
export class FormatSeniorityPipe implements PipeTransform {
  transform(value: any): any {
    if (!value) {
      return value;
    }

    switch (value) {
      case 'Senior':
        return 'Sénior';
      case 'Junior':
        return 'Junior';
      case 'Interne':
        return 'Interne';
      default:
        return value;
    }
  }
}
